import React from 'react';
import styled from '@emotion/styled';
import Layout from '../components/layout/Layout';
import Seo from '../components/seo/Seo';
import { theme } from '../styles/theme';
import {
  WebsiteSection,
  WebsiteSectionContainer,
  WebsitePageHeader,
  WebsitePageTitle,
  WebsitePageIntro,
  WebsiteContentBlock,
  WebsitePageSectionTitle,
  WebsiteBodyText,
  WebsiteCard,
} from '../components/common/websiteSection';

const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: ${theme.spacing.lg};
`;

const ValueCard = styled(WebsiteCard)`
  padding: ${theme.spacing.xl};

  h3 {
    margin: 0 0 ${theme.spacing.sm};
    font-size: ${theme.typography.fontSize.lg};
    font-weight: 700;
    letter-spacing: -0.02em;
    color: var(--login-form-text);
  }

  p {
    margin: 0;
    font-size: ${theme.typography.fontSize.base};
    line-height: 1.65;
    color: var(--login-form-muted);
  }
`;

const VALUES = [
  {
    title: 'Innovation',
    copy: 'Constantly improving our platform with cutting-edge solutions.',
  },
  {
    title: 'Reliability',
    copy: 'Providing a stable and secure platform you can count on.',
  },
  {
    title: 'Customers First',
    copy: 'Your success is our success. We are here to support your growth.',
  },
  {
    title: 'Traditional Values',
    copy:
      'We still believe a handshake means something. At Neat Schedule, we lead with integrity, treat people with real respect, and show up with sincerity and heart.',
  },
];

export default function AboutPage() {
  return (
    <Layout>
      <Seo
        title="About Neat Schedule"
        description="Learn about Neat Schedule — our story, mission, and values as we help service businesses manage scheduling and client relationships."
        canonicalPath="/about"
        keywords={['about Neat Schedule', 'scheduling software company', 'appointment management']}
      />
      <WebsiteSection>
        <WebsiteSectionContainer>
          <WebsitePageHeader>
            <WebsitePageTitle>About Neat Schedule</WebsitePageTitle>
            <WebsitePageIntro>
              Empowering businesses to manage their time efficiently and grow their customer relationships.
            </WebsitePageIntro>
          </WebsitePageHeader>

          <WebsiteContentBlock>
            <WebsitePageSectionTitle>Our Story</WebsitePageSectionTitle>
            <WebsiteBodyText>
              Founded in 2024, Neat Schedule started as a simple idea: there is no reason businesses should
              have to work so hard to maintain their schedules and hurt their pocketbook at the same time.
              There are many solutions out there for scheduling needs, but at Neat Schedule we aim to provide
              the same great services and more, at a much more reasonable price.
            </WebsiteBodyText>
          </WebsiteContentBlock>

          <WebsiteContentBlock>
            <WebsitePageSectionTitle>Our Mission</WebsitePageSectionTitle>
            <WebsiteBodyText>
              We are on a mission to simplify business scheduling and enhance customer relationships through
              innovative technology solutions that save time and reduce complexity.
            </WebsiteBodyText>
            <WebsiteBodyText>
              From small businesses to larger teams, you need something reliable and easy to use — something
              your employees and clients will enjoy. We aim to grow with you and provide everything you would
              expect from a scheduling solution.
            </WebsiteBodyText>
          </WebsiteContentBlock>

          <WebsiteContentBlock>
            <WebsitePageSectionTitle>Our Values</WebsitePageSectionTitle>
            <ValuesGrid>
              {VALUES.map((item) => (
                <ValueCard key={item.title}>
                  <h3>{item.title}</h3>
                  <p>{item.copy}</p>
                </ValueCard>
              ))}
            </ValuesGrid>
          </WebsiteContentBlock>
        </WebsiteSectionContainer>
      </WebsiteSection>
    </Layout>
  );
}
